let demoCode = `G01X363.369Y20.810
G01X486.469Y36.620
G01X485.438Y44.504
G01X484.469Y51.398
G01X483.375Y58.277
G01X480.993Y71.966
G01X479.487Y79.987
G01X477.783Y87.963
G03X474.030Y104.705I-481.324J-99.116
G03X468.512Y126.180I-797.644J-193.506
G01X466.672Y132.897
G01X464.698Y139.575
G03X449.366Y186.088I-741.190J-218.536
G03X427.780Y240.677I-1042.762J-380.769
G03X410.094Y280.390I-1251.558J-533.576
G03X382.371Y338.409I-2699.404J-1254.214

`
demoCode = `(Data: 2023/11/09 Time: 22:30:32)
(Bezier Tolerance 0.10)
(Powered by CypNest)
()

"PRGSTART"
$IF V.E.Go==1
G90
G00 X5.000 Y4.999
G00 X5.000 Y1465.390
G00 X197.224 Y1465.390
G00 X197.224 Y4.999
G00 X5.000 Y4.999
V.E.Go=0
M30
$ENDIF

G90

"SPLINE"
N1
G00 X59.862 Y175.679
"BEAMON"
G01 X63.398 Y179.214
G03 X54.443 Y170.259 I-4.478 J-4.478
G03 X63.398 Y179.214 I4.478 J4.478
G01 X59.862 Y175.679
"BEAMOFF"

"SPLINE"
N2
G00 X70.084 Y215.735
"BEAMON"
G01 X73.620 Y219.271
G03 X64.490 Y210.141 I-4.565 J-4.565
G03 X73.620 Y219.271 I4.565 J4.565
G01 X70.084 Y215.735
"BEAMOFF"

"SPLINE"
N3
G00 X140.604 Y254.992
"BEAMON"
G01 X135.758 Y256.351
G01 X132.249 Y265.303
G03 X119.539 Y276.045 I-17.792 J-8.161
G01 X13.843 Y306.038
G03 X10.382 Y305.399 I-0.995 J-4.303
G01 X5.022 Y300.991
G03 X5.353 Y296.950 I14.926 J-0.812
G02 X13.669 Y253.294 I-427.382 J-104.036
G02 X19.795 Y202.468 I-424.122 J-76.900
G02 X21.447 Y134.115 I-578.209 J-48.171
G02 X7.777 Y19.959 I-737.096 J30.371
G03 X55.668 Y66.473 I-38.938 J88.002
G03 X59.768 Y79.463 I-57.311 J25.232
G02 X60.960 Y90.287 I334.066 J-31.323
G02 X66.774 Y104.846 I24.103 J-1.185
G02 X76.452 Y112.961 I29.662 J-25.545
G03 X94.977 Y136.044 I-18.592 J33.895
G03 X96.689 Y140.306 I-32.800 J15.649
G03 X99.502 Y166.653 I-426.754 J58.893
G02 X111.975 Y201.607 I58.153 J-1.049
G02 X130.904 Y216.047 I343.439 J-430.566
G03 X136.714 Y227.092 I-10.505 J12.577
G03 X135.758 Y256.351 I-65.746 J12.498
G01 X140.599 Y257.604
"BEAMOFF"

"SPLINE"
N4
G00 X59.862 Y465.489
"BEAMON"
G01 X63.398 Y469.024
G03 X54.443 Y460.069 I-4.478 J-4.478
G03 X63.398 Y469.024 I4.478 J4.478
G01 X59.862 Y465.489
"BEAMOFF"

"SPLINE"
N5
G00 X70.084 Y505.545
"BEAMON"
G01 X73.620 Y509.080
G03 X64.490 Y499.950 I-4.565 J-4.565
G03 X73.620 Y509.080 I4.565 J4.565
G01 X70.084 Y505.545
"BEAMOFF"

"SPLINE"
N6
G00 X140.604 Y544.802
"BEAMON"
G01 X135.758 Y546.161
G01 X132.249 Y555.113
G03 X119.539 Y565.855 I-17.792 J-8.161
G01 X13.843 Y595.848
G03 X10.382 Y595.209 I-0.995 J-4.303
G01 X5.022 Y590.801
G03 X5.353 Y586.759 I14.926 J-0.812
G02 X13.669 Y543.104 I-427.382 J-104.036
G02 X19.795 Y492.278 I-424.122 J-76.900
G02 X21.447 Y423.925 I-578.209 J-48.171
G02 X7.777 Y309.768 I-737.096 J30.371
G03 X55.668 Y356.283 I-38.938 J88.002
G03 X59.768 Y369.272 I-57.311 J25.232
G02 X60.960 Y380.096 I334.066 J-31.323
G02 X66.774 Y394.656 I24.103 J-1.185
G02 X76.452 Y402.771 I29.662 J-25.545
G03 X94.977 Y425.854 I-18.592 J33.895
G03 X96.689 Y430.116 I-32.800 J15.649
G03 X99.502 Y456.463 I-426.754 J58.893
G02 X111.975 Y491.417 I58.153 J-1.049
G02 X130.904 Y505.857 I343.439 J-430.566
G03 X136.714 Y516.902 I-10.505 J12.577
G03 X135.758 Y546.161 I-65.746 J12.498
G01 X140.599 Y547.413
"BEAMOFF"

"SPLINE"
N7
G00 X59.862 Y755.298
"BEAMON"
G01 X63.398 Y758.834
G03 X54.443 Y749.879 I-4.478 J-4.478
G03 X63.398 Y758.834 I4.478 J4.478
G01 X59.862 Y755.298
"BEAMOFF"

"SPLINE"
N8
G00 X70.084 Y795.355
"BEAMON"
G01 X73.620 Y798.890
G03 X64.490 Y789.760 I-4.565 J-4.565
G03 X73.620 Y798.890 I4.565 J4.565
G01 X70.084 Y795.355
"BEAMOFF"

"SPLINE"
N9
G00 X140.604 Y834.612
"BEAMON"
G01 X135.758 Y835.971
G01 X132.249 Y844.922
G03 X119.539 Y855.664 I-17.792 J-8.161
G01 X13.843 Y885.657
G03 X10.382 Y885.018 I-0.995 J-4.303
G01 X5.022 Y880.610
G03 X5.353 Y876.569 I14.926 J-0.812
G02 X13.669 Y832.913 I-427.382 J-104.036
G02 X19.795 Y782.088 I-424.122 J-76.900
G02 X21.447 Y713.735 I-578.209 J-48.171
G02 X7.777 Y599.578 I-737.096 J30.371
G03 X55.668 Y646.093 I-38.938 J88.002
G03 X59.768 Y659.082 I-57.311 J25.232
G02 X60.960 Y669.906 I334.066 J-31.323
G02 X66.774 Y684.465 I24.103 J-1.185
G02 X76.452 Y692.581 I29.662 J-25.545
G03 X94.977 Y715.663 I-18.592 J33.895
G03 X96.689 Y719.925 I-32.800 J15.649
G03 X99.502 Y746.273 I-426.754 J58.893
G02 X111.975 Y781.227 I58.153 J-1.049
G02 X130.904 Y795.667 I343.439 J-430.566
G03 X136.714 Y806.711 I-10.505 J12.577
G03 X135.758 Y835.971 I-65.746 J12.498
G01 X140.599 Y837.223
"BEAMOFF"

"SPLINE"
N10
G00 X59.862 Y1045.108
"BEAMON"
G01 X63.398 Y1048.643
G03 X54.443 Y1039.688 I-4.478 J-4.478
G03 X63.398 Y1048.643 I4.478 J4.478
G01 X59.862 Y1045.108
"BEAMOFF"

"SPLINE"
N11
G00 X70.084 Y1085.164
"BEAMON"
G01 X73.620 Y1088.700
G03 X64.490 Y1079.570 I-4.565 J-4.565
G03 X73.620 Y1088.700 I4.565 J4.565
G01 X70.084 Y1085.164
"BEAMOFF"

"SPLINE"
N12
G00 X140.604 Y1124.421
"BEAMON"
G01 X135.758 Y1125.780
G01 X132.249 Y1134.732
G03 X119.539 Y1145.474 I-17.792 J-8.161
G01 X13.843 Y1175.467
G03 X10.382 Y1174.828 I-0.995 J-4.303
G01 X5.022 Y1170.420
G03 X5.353 Y1166.379 I14.926 J-0.812
G02 X13.669 Y1122.723 I-427.382 J-104.036
G02 X19.795 Y1071.898 I-424.122 J-76.900
G02 X21.447 Y1003.544 I-578.209 J-48.171
G02 X7.777 Y889.388 I-737.096 J30.371
G03 X55.668 Y935.902 I-38.938 J88.002
G03 X59.768 Y948.892 I-57.311 J25.232
G02 X60.960 Y959.716 I334.066 J-31.323
G02 X66.774 Y974.275 I24.103 J-1.185
G02 X76.452 Y982.390 I29.662 J-25.545
G03 X94.977 Y1005.473 I-18.592 J33.895
G03 X96.689 Y1009.735 I-32.800 J15.649
G03 X99.502 Y1036.082 I-426.754 J58.893
G02 X111.975 Y1071.036 I58.153 J-1.049
G02 X130.904 Y1085.476 I343.439 J-430.566
G03 X136.714 Y1096.521 I-10.505 J12.577
G03 X135.758 Y1125.780 I-65.746 J12.498
G01 X140.599 Y1127.033
"BEAMOFF"

"SPLINE"
N13
G00 X59.862 Y1334.918
"BEAMON"
G01 X63.398 Y1338.453
G03 X54.443 Y1329.498 I-4.478 J-4.478
G03 X63.398 Y1338.453 I4.478 J4.478
G01 X59.862 Y1334.918
"BEAMOFF"

"SPLINE"
N14
G00 X70.084 Y1374.974
"BEAMON"
G01 X73.620 Y1378.509
G03 X64.490 Y1369.379 I-4.565 J-4.565
G03 X73.620 Y1378.509 I4.565 J4.565
G01 X70.084 Y1374.974
"BEAMOFF"

"SPLINE"
N15
G00 X140.604 Y1414.231
"BEAMON"
G01 X135.758 Y1415.590
G01 X132.249 Y1424.542
G03 X119.539 Y1435.284 I-17.792 J-8.161
G01 X13.843 Y1465.277
G03 X10.382 Y1464.638 I-0.995 J-4.303
G01 X5.022 Y1460.230
G03 X5.353 Y1456.188 I14.926 J-0.812
G02 X13.669 Y1412.533 I-427.382 J-104.036
G02 X19.795 Y1361.707 I-424.122 J-76.900
G02 X21.447 Y1293.354 I-578.209 J-48.171
G02 X7.777 Y1179.197 I-737.096 J30.371
G03 X55.668 Y1225.712 I-38.938 J88.002
G03 X59.768 Y1238.701 I-57.311 J25.232
G02 X60.960 Y1249.526 I334.066 J-31.323
G02 X66.774 Y1264.085 I24.103 J-1.185
G02 X76.452 Y1272.200 I29.662 J-25.545
G03 X94.977 Y1295.283 I-18.592 J33.895
G03 X96.689 Y1299.545 I-32.800 J15.649
G03 X99.502 Y1325.892 I-426.754 J58.893
G02 X111.975 Y1360.846 I58.153 J-1.049
G02 X130.904 Y1375.286 I343.439 J-430.566
G03 X136.714 Y1386.331 I-10.505 J12.577
G03 X135.758 Y1415.590 I-65.746 J12.498
G01 X140.599 Y1416.842
"BEAMOFF"

"SPLINE"
N16
G00 X142.362 Y1294.710
"BEAMON"
G01 X138.827 Y1291.175
G03 X147.782 Y1300.130 I4.478 J4.478
G03 X138.827 Y1291.175 I-4.478 J-4.478
G01 X142.362 Y1294.710
"BEAMOFF"

"SPLINE"
N17
G00 X132.140 Y1254.654
"BEAMON"
G01 X128.604 Y1251.118
G03 X137.734 Y1260.248 I4.565 J4.565
G03 X128.604 Y1251.118 I-4.565 J-4.565
G01 X132.140 Y1254.654
"BEAMOFF"

"SPLINE"
N18
G00 X61.620 Y1215.397
"BEAMON"
G01 X66.466 Y1214.038
G01 X69.975 Y1205.086
G03 X82.685 Y1194.344 I17.792 J8.161
G01 X188.382 Y1164.351
G03 X191.842 Y1164.990 I0.995 J4.303
G01 X197.202 Y1169.398
G03 X196.871 Y1173.439 I-14.926 J0.812
G02 X188.555 Y1217.095 I427.382 J104.035
G02 X182.429 Y1267.921 I424.122 J76.900
G02 X180.777 Y1336.274 I578.208 J48.171
G02 X194.448 Y1450.431 I737.096 J-30.371
G03 X146.556 Y1403.916 I38.938 J-88.002
G03 X142.456 Y1390.926 I57.311 J-25.232
G02 X141.264 Y1380.102 I-334.067 J31.323
G02 X135.450 Y1365.543 I-24.103 J1.185
G02 X125.772 Y1357.428 I-29.662 J25.545
G03 X107.247 Y1334.345 I18.592 J-33.895
G03 X105.536 Y1330.083 I32.800 J-15.649
G03 X102.722 Y1303.736 I426.754 J-58.893
G02 X90.249 Y1268.782 I-58.153 J1.049
G02 X71.320 Y1254.342 I-343.439 J430.567
G03 X65.510 Y1243.297 I10.505 J-12.577
G03 X66.466 Y1214.038 I65.746 J-12.498
G01 X61.625 Y1212.786
"BEAMOFF"

"SPLINE"
N19
G00 X142.362 Y1004.901
"BEAMON"
G01 X138.827 Y1001.365
G03 X147.782 Y1010.320 I4.478 J4.478
G03 X138.827 Y1001.365 I-4.478 J-4.478
G01 X142.362 Y1004.901
"BEAMOFF"

"SPLINE"
N20
G00 X132.140 Y964.844
"BEAMON"
G01 X128.604 Y961.309
G03 X137.734 Y970.439 I4.565 J4.565
G03 X128.604 Y961.309 I-4.565 J-4.565
G01 X132.140 Y964.844
"BEAMOFF"

"SPLINE"
N21
G00 X61.620 Y925.587
"BEAMON"
G01 X66.466 Y924.228
G01 X69.975 Y915.276
G03 X82.685 Y904.534 I17.792 J8.161
G01 X188.382 Y874.542
G03 X191.842 Y875.180 I0.995 J4.303
G01 X197.202 Y879.589
G03 X196.871 Y883.630 I-14.926 J0.812
G02 X188.555 Y927.285 I427.382 J104.035
G02 X182.429 Y978.111 I424.122 J76.900
G02 X180.777 Y1046.464 I578.208 J48.171
G02 X194.448 Y1160.621 I737.096 J-30.371
G03 X146.556 Y1114.106 I38.938 J-88.002
G03 X142.456 Y1101.117 I57.311 J-25.232
G02 X141.264 Y1090.293 I-334.067 J31.323
G02 X135.450 Y1075.734 I-24.103 J1.185
G02 X125.772 Y1067.618 I-29.662 J25.545
G03 X107.247 Y1044.535 I18.592 J-33.895
G03 X105.536 Y1040.274 I32.800 J-15.649
G03 X102.722 Y1013.926 I426.754 J-58.893
G02 X90.249 Y978.972 I-58.153 J1.049
G02 X71.320 Y964.532 I-343.439 J430.567
G03 X65.510 Y953.487 I10.505 J-12.577
G03 X66.466 Y924.228 I65.746 J-12.498
G01 X61.625 Y922.976
"BEAMOFF"

"SPLINE"
N22
G00 X142.362 Y715.091
"BEAMON"
G01 X138.827 Y711.555
G03 X147.782 Y720.510 I4.478 J4.478
G03 X138.827 Y711.555 I-4.478 J-4.478
G01 X142.362 Y715.091
"BEAMOFF"

"SPLINE"
N23
G00 X132.140 Y675.035
"BEAMON"
G01 X128.604 Y671.499
G03 X137.734 Y680.629 I4.565 J4.565
G03 X128.604 Y671.499 I-4.565 J-4.565
G01 X132.140 Y675.035
"BEAMOFF"

"SPLINE"
N24
G00 X61.620 Y635.777
"BEAMON"
G01 X66.466 Y634.418
G01 X69.975 Y625.467
G03 X82.685 Y614.725 I17.792 J8.161
G01 X188.382 Y584.732
G03 X191.842 Y585.371 I0.995 J4.303
G01 X197.202 Y589.779
G03 X196.871 Y593.820 I-14.926 J0.812
G02 X188.555 Y637.476 I427.382 J104.035
G02 X182.429 Y688.301 I424.122 J76.900
G02 X180.777 Y756.654 I578.208 J48.171
G02 X194.448 Y870.811 I737.096 J-30.371
G03 X146.556 Y824.297 I38.938 J-88.002
G03 X142.456 Y811.307 I57.311 J-25.232
G02 X141.264 Y800.483 I-334.067 J31.323
G02 X135.450 Y785.924 I-24.103 J1.185
G02 X125.772 Y777.808 I-29.662 J25.545
G03 X107.247 Y754.726 I18.592 J-33.895
G03 X105.536 Y750.464 I32.800 J-15.649
G03 X102.722 Y724.117 I426.754 J-58.893
G02 X90.249 Y689.162 I-58.153 J1.049
G02 X71.320 Y674.722 I-343.439 J430.567
G03 X65.510 Y663.678 I10.505 J-12.577
G03 X66.466 Y634.418 I65.746 J-12.498
G01 X61.625 Y633.166
"BEAMOFF"

"SPLINE"
N25
G00 X142.362 Y425.281
"BEAMON"
G01 X138.827 Y421.746
G03 X147.782 Y430.701 I4.478 J4.478
G03 X138.827 Y421.746 I-4.478 J-4.478
G01 X142.362 Y425.281
"BEAMOFF"

"SPLINE"
N26
G00 X132.140 Y385.225
"BEAMON"
G01 X128.604 Y381.689
G03 X137.734 Y390.819 I4.565 J4.565
G03 X128.604 Y381.689 I-4.565 J-4.565
G01 X132.140 Y385.225
"BEAMOFF"

"SPLINE"
N27
G00 X61.620 Y345.968
"BEAMON"
G01 X66.466 Y344.609
G01 X69.975 Y335.657
G03 X82.685 Y324.915 I17.792 J8.161
G01 X188.382 Y294.922
G03 X191.842 Y295.561 I0.995 J4.303
G01 X197.202 Y299.969
G03 X196.871 Y304.010 I-14.926 J0.812
G02 X188.555 Y347.666 I427.382 J104.035
G02 X182.429 Y398.492 I424.122 J76.900
G02 X180.777 Y466.845 I578.208 J48.171
G02 X194.448 Y581.002 I737.096 J-30.371
G03 X146.556 Y534.487 I38.938 J-88.002
G03 X142.456 Y521.497 I57.311 J-25.232
G02 X141.264 Y510.673 I-334.067 J31.323
G02 X135.450 Y496.114 I-24.103 J1.185
G02 X125.772 Y487.999 I-29.662 J25.545
G03 X107.247 Y464.916 I18.592 J-33.895
G03 X105.536 Y460.654 I32.800 J-15.649
G03 X102.722 Y434.307 I426.754 J-58.893
G02 X90.249 Y399.353 I-58.153 J1.049
G02 X71.320 Y384.913 I-343.439 J430.567
G03 X65.510 Y373.868 I10.505 J-12.577
G03 X66.466 Y344.609 I65.746 J-12.498
G01 X61.625 Y343.356
"BEAMOFF"

"SPLINE"
N28
G00 X142.362 Y135.472
"BEAMON"
G01 X138.827 Y131.936
G03 X147.782 Y140.891 I4.478 J4.478
G03 X138.827 Y131.936 I-4.478 J-4.478
G01 X142.362 Y135.472
"BEAMOFF"

"SPLINE"
N29
G00 X132.140 Y95.415
"BEAMON"
G01 X128.604 Y91.880
G03 X137.734 Y101.010 I4.565 J4.565
G03 X128.604 Y91.880 I-4.565 J-4.565
G01 X132.140 Y95.415
"BEAMOFF"

"SPLINE"
N30
G00 X61.620 Y56.158
"BEAMON"
G01 X66.466 Y54.799
G01 X69.975 Y45.847
G03 X82.685 Y35.105 I17.792 J8.161
G01 X188.382 Y5.112
G03 X191.842 Y5.751 I0.995 J4.303
G01 X197.202 Y10.159
G03 X196.871 Y14.201 I-14.926 J0.812
G02 X188.555 Y57.856 I427.382 J104.035
G02 X182.429 Y108.682 I424.122 J76.900
G02 X180.777 Y177.035 I578.208 J48.171
G02 X194.448 Y291.192 I737.096 J-30.371
G03 X146.556 Y244.677 I38.938 J-88.002
G03 X142.456 Y231.688 I57.311 J-25.232
G02 X141.264 Y220.864 I-334.067 J31.323
G02 X135.450 Y206.304 I-24.103 J1.185
G02 X125.772 Y198.189 I-29.662 J25.545
G03 X107.247 Y175.106 I18.592 J-33.895
G03 X105.536 Y170.845 I32.800 J-15.649
G03 X102.722 Y144.497 I426.754 J-58.893
G02 X90.249 Y109.543 I-58.153 J1.049
G02 X71.320 Y95.103 I-343.439 J430.567
G03 X65.510 Y84.058 I10.505 J-12.577
G03 X66.466 Y54.799 I65.746 J-12.498
G01 X61.625 Y53.547
"BEAMOFF"

"PRGEND"
M30
`
export const toCncCodes = function (gcodeString) {
    let from = gcodeString
    // 删除一些没用的代码
    // from = from.replaceAll(/".*"/g, '')
    from = from.replaceAll(/\$IF[\s\S]*\$ENDIF/g, '')
    from = from.replaceAll(/\(.*\)/g, '')

    let lines = from.split('\n')
    const reg = /[A-Za-z]-?\d+(\.\d+)?/g
    const isNum = (v) => typeof v === 'number'
// 设置缩放倍率 =1时不缩放
    let toViewer = 1
    const fixed5 = (xy) => (xy / toViewer).toFixed(9) - 0
// cncCodes = [{
//   "G": 3,
//   "X": 5.27,
//   "Y": 846.155,
//   "I": 487.663,
//   "J": -0.418
// }]
    let cncCodes = []
    for (let i in lines) {
        let line = lines[i]
        if (line.trim().length === 0) continue
        let rs = line.match(reg)
        let cnc
        if (rs) {
            cnc = {}
            rs.forEach(code => {
                let key = code[0]
                cnc[key] = code.substring(1) - 0
            })
            if (isNum(cnc.I)) cnc.I = fixed5(cnc.I)
            if (isNum(cnc.J)) cnc.J = fixed5(cnc.J)
            if (isNum(cnc.X)) cnc.X = fixed5(cnc.X)
            if (isNum(cnc.Y)) cnc.Y = fixed5(cnc.Y)
        } else {
            cnc = line
        }
        cncCodes.push(cnc)
    }
    return cncCodes
}


export const toCncCut = (cncCodes) => {
    let r = ''
    for (let i in cncCodes) {
        let cnc = cncCodes[i]
        if (!cnc)
            continue
        if (typeof cnc === 'string') {
            if (cnc.startsWith('"PRGSTART"'))
                r += 'G92 X0 Y0\nG90\n'
            else if (cnc.startsWith('"PRGEND"'))
                r += 'M02\n'
            else if (cnc.startsWith('"BEAMON"') || cnc.startsWith('"CUTON"'))
                r += 'M07\n'
            else if (cnc.startsWith('"BEAMOFF"'))
                r += 'M08\n'
        } else if (cnc.G === 0 || cnc.G === 1)
            r += `G0${cnc.G}X${cnc.X}Y${cnc.Y}\n`
        else if (cnc.G === 2 || cnc.G === 3)
            r += `G0${cnc.G}X${cnc.X}Y${cnc.Y}I${cnc.I}J${cnc.J}\n`
    }
    return r
}

export const demoCnc = toCncCodes(demoCode)

console.log('demo cnc', demoCnc)

export default demoCode
